<template>
    <div class="line-divider"></div>
</template>